import { combineReducers } from "@reduxjs/toolkit";

import dialogStore from "store/slices/dialog.store";
import userStore from "store/slices/user.store";
import rootStore from "./root.store";
import bookInPartsStore from "./slices/bookInParts.store";
import cacheStore from "./slices/cache.store";
import calendarStore from "./slices/calendar.store";
import createJobStore from "./slices/dialogs/createJob.store";
import feedbackStore from "./slices/dialogs/feedback.store";
import noteStore from "./slices/dialogs/note.store";
import historyStore from "./slices/history.store";
import jobsStore from "./slices/jobs.store";
import menuStore from "./slices/menu.store";
import plannerStore from "./slices/planner.store";
import snackbarStore from "./slices/snackbar.store";
import stockStore from "./slices/stock.store";
import createEventStore from "./slices/dialogs/createEvent.store";
import createSalesOrderStore from "./slices/dialogs/createSalesOrder.store";
import floorplansStore from "./slices/floorplans.store";
import deviceStatusStore from "./slices/deviceStatus.store";
import addPartStore from "./slices/dialogs/addPart.store"
import filesStore from "./slices/files.store";
import editSpecificationStore from "./slices/dialogs/editSpecification.store";
import inspectionResultsStore from "./slices/inspectionResults.store"

export const reducers = combineReducers({
  bookInParts: bookInPartsStore,
  cache: cacheStore,
  calendar: calendarStore,
  createJob: createJobStore,
  createEvent: createEventStore,
  createSalesOrder: createSalesOrderStore,
  dialog: dialogStore,
  feedback: feedbackStore,
  history: historyStore,
  jobs: jobsStore,
  menu: menuStore,
  note: noteStore,
  planner: plannerStore,
  root: rootStore,
  snackbar: snackbarStore,
  stock: stockStore,
  user: userStore,
  floorplans: floorplansStore,
  deviceStatus: deviceStatusStore,
  addPart: addPartStore,
  files: filesStore,
  editSpecification: editSpecificationStore,
  inspectionResults: inspectionResultsStore,
});
